import React from 'react'

import './page-layout.scss'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    children: React.ReactNode
    header?: React.ReactNode
    footer?: React.ReactNode
    fixedHeight?: boolean
    toasts?: React.ReactNode
  }
>

const PageLayout = ({
  className,
  children,
  header,
  footer,
  fixedHeight = false,
  toasts,
  ...props
}: Props) => (
  <div {...props} className={cn('PageLayout', {fixedHeight}, className)}>
    {header && <div className="PageLayout__header">{header}</div>}
    <div className="PageLayout__main">
      <div className="PageLayout__content">{children}</div>
      {footer && <div className="PageLayout__footer">{footer}</div>}
      {toasts && <div className="PageLayout__toasts">{toasts}</div>}
    </div>
  </div>
)

export default PageLayout
